/**
 * @generated SignedSource<<148a7d8c8d2b3cee50bcbdddae59eb66>>
 * @relayHash 157a52d310a2bb45a947c5682ad3e70e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9db424d7408a3f207ff22d38862a6f452caf7d771e634a17cb58628cbbd23101

import type { ConcreteRequest } from 'relay-runtime';
export type ContentStateRestrictionLevel = "NONE" | "PAGE_OWNER" | "%future added value";
export type StatusAndApprovalsConfigSettingsQuery$variables = {
  spaceKey: string;
};
export type StatusAndApprovalsConfigSettingsQuery$data = {
  readonly space: {
    readonly id: string | null | undefined;
    readonly settings: {
      readonly contentStateSettings: {
        readonly contentStatesAllowed: boolean | null | undefined;
        readonly customContentStatesAllowed: boolean | null | undefined;
        readonly spaceContentStates: ReadonlyArray<{
          readonly color: string;
          readonly id: string | null | undefined;
          readonly name: string;
          readonly restrictionLevel: ContentStateRestrictionLevel;
        } | null | undefined> | null | undefined;
        readonly spaceContentStatesAllowed: boolean | null | undefined;
      };
    } | null | undefined;
    readonly spaceTypeSettings: {
      readonly enabledFeatures: {
        readonly isContentApprovalsEnabled: boolean | null | undefined;
      };
    };
  } | null | undefined;
};
export type StatusAndApprovalsConfigSettingsQuery = {
  response: StatusAndApprovalsConfigSettingsQuery$data;
  variables: StatusAndApprovalsConfigSettingsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "Space",
    "kind": "LinkedField",
    "name": "space",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "concreteType": "SpaceSettings",
        "kind": "LinkedField",
        "name": "settings",
        "plural": false,
        "selections": [
          {
            "concreteType": "ContentStateSettings",
            "kind": "LinkedField",
            "name": "contentStateSettings",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "contentStatesAllowed"
              },
              {
                "kind": "ScalarField",
                "name": "spaceContentStatesAllowed"
              },
              {
                "kind": "ScalarField",
                "name": "customContentStatesAllowed"
              },
              {
                "concreteType": "ContentState",
                "kind": "LinkedField",
                "name": "spaceContentStates",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "name"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "color"
                  },
                  (v1/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "restrictionLevel"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "concreteType": "SpaceTypeSettings",
        "kind": "LinkedField",
        "name": "spaceTypeSettings",
        "plural": false,
        "selections": [
          {
            "concreteType": "EnabledFeatures",
            "kind": "LinkedField",
            "name": "enabledFeatures",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "isContentApprovalsEnabled"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "StatusAndApprovalsConfigSettingsQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StatusAndApprovalsConfigSettingsQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "157a52d310a2bb45a947c5682ad3e70e",
    "id": "9db424d7408a3f207ff22d38862a6f452caf7d771e634a17cb58628cbbd23101",
    "metadata": {},
    "name": "StatusAndApprovalsConfigSettingsQuery",
    "operationKind": "query",
    "text": "query StatusAndApprovalsConfigSettingsQuery($spaceKey:String!){space(key:$spaceKey){id,settings{contentStateSettings{contentStatesAllowed,spaceContentStatesAllowed,customContentStatesAllowed,spaceContentStates{name,color,id,restrictionLevel}}},spaceTypeSettings{enabledFeatures{isContentApprovalsEnabled}}}}"
  }
};
})();

(node as any).hash = "56245d911a1da1b58254ccfa0962d2e7";

export default node;
